/* Componente per selezionare il valore per eseguire la query*/
import React from 'react';
import {useEffect} from 'react'

function SelectValue(props) {

  const [layerValue, setLayerValue] = React.useState('')
  const [betweenValue_1, setbetweenValue_1] = React.useState('')
  const [betweenValue_2, setbetweenValue_2] = React.useState('')

  useEffect(()=>{
    setLayerValue('')
  },[props.start])

  const handleChange = (event) => {
    setLayerValue(event.target.value)
    props.callback(event.target.value)
  };
  const betweenChange_1 = (event) => {
   setbetweenValue_1(event.target.value)
    props.callback(`${event.target.value} AND ${betweenValue_2}` )
  };
  const betweenChange_2 = (event) => {
    setbetweenValue_2(event.target.value)
    props.callback(`${betweenValue_1} AND ${event.target.value}`)
  };
  
    switch (props.operator.name) {
      
      case "IS NULL":
      
        return (
          <input  className={"inputValue"} type="text" onChange={handleChange} value={' NULL'} disabled={true} />
     )
      case "IS NOT NULL":
      
        return (
          <input  className={"inputValue"} type="text" onChange={handleChange} value={' NULL'} disabled={true} />
     )
      case "BETWEEN":
      
        return (<div>
          <input  className={"betweenValue"} type="text" onChange={betweenChange_1} value={betweenValue_1} />
          <input  className={"betweenValue"} type="text" onChange={betweenChange_2} value={betweenValue_2} />
          </div>
     )
      case "NOT BETWEEN":
      
        return (
          <div>
          <input  className={"betweenValue"} type="text" onChange={betweenChange_1} value={betweenValue_1} />
          <input  className={"betweenValue"} type="text" onChange={betweenChange_2} value={betweenValue_2} />
          </div>
     )
    default:
      return (
        <input  className={"inputValue"} type="text" onChange={handleChange} value={layerValue} />
   );
  }
  



  }


  export default SelectValue